export default __webpack_public_path__ + "static/media/wallet.1309eeb9.svg";